import React, { useEffect, useState } from 'react'
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import api from '../../utils/api';
import DreamBigProgramManagerLandingPageTable from './DreamBigProgramManagerLandingPageTable';
import Spinner from '../../common/Spinner/Spinner';



const DreamBigLandingPage = (props) => {

  const [programManagerList, setProgramManagerList] = useState([])
  const [shouldOpen, setShouldOpen] = React.useState(true);
  const SELECT_ALL_OPTION = { label: "Select All", value: "__all__" };

  const Option = (props) => {
    const { data, selectProps } = props;

    const isSelectAll = data.value === "__all__";
    const allOptions = selectProps.options.filter(opt => opt.value !== "__all__");
    const selected = selectProps.value || [];

    const isAllSelected = allOptions.length > 0 && selected.length === allOptions.length;

    const isChecked = isSelectAll ? isAllSelected : props.isSelected;

    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => null}
          style={{ marginRight: 8, zIndex: 1000}}
        />
        {props.label}
      </components.Option>
    );
  };


  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#e6f7ff" : "white",
      color: "black",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Makes sure it's on top
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };



  const handleMenuOpen = () => {
    if (!props.selectedProgramManager || props.selectedProgramManager.length == 0) {
      setShouldOpen(true);
    } else {
      setShouldOpen(true);
    }
  };

  useEffect(() => {
    const { tempProgramManagerListDreamBigUser } = api.getDistinctResourceDisplayNames()
      .then(({ data }) => {
        const formattedOptions = data.data
          .filter(item => item !== null)
          .map(item => ({
            label: item,
            value: item
          }));
        setProgramManagerList(formattedOptions)
      })
  }, [])



  const onProgramManagerChange = (option, { action }) => {
    const allOptions = programManagerList; // exclude the SELECT_ALL_OPTION
    const isSelectAll = option?.some?.(opt => opt.value === "__all__");
  
    if (isSelectAll) {
      // If all already selected → clear all
      if (option.length - 1 === allOptions.length) {
        props.setSelectedResourceName([]);
        props.getUserCountByResource([]);
      } else {
        // Select all
        props.setSelectedResourceName(allOptions);
        props.getUserCountByResource(allOptions);
      }
    } else {
      // Normal case
      props.setSelectedResourceName(option || []);
      props.getUserCountByResource(option || []);
    }
  };
  

  
  
  return (
    <div>
      <h3
        className="spled-black-text"
        style={{
          fontSize: "25px",
          marginRight: 10,
          textAlign: 'center',
          // margin: 10
        }}
      >
        Landing Page User Data
      </h3>
      <div className="row mt-4 mb-4">
        <div className="col-md-6">

          <Select
            options={
                programManagerList && programManagerList.length > 0
                ? [SELECT_ALL_OPTION, ...programManagerList]
                : []
            }
            onChange={onProgramManagerChange}
            value={props.selectedResourceName}
            placeholder="Select Resource Name"
            isMulti
            isClearable
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{ Option }}
            styles={customStyles}
            onMenuOpen={handleMenuOpen}
            menuIsOpen={shouldOpen ? undefined : false}
          />
        </div>
      </div>


      <div className="row mt-3 mb-3">
          <DreamBigProgramManagerLandingPageTable
            fromDate={props.fromDate}
            toDate={props.toDate}
            selectedResourceName={props.selectedResourceName}
            resourceDataSelectedPartner={props.resourceDataSelectedPartner}
            selectedPartnerName={props.selectedPartnerName}
            setSelectedPartnerName={props.setSelectedPartnerName}
            getResourceDataForSelectedPartner={props.getResourceDataForSelectedPartner}
            partnerDataProgramManager={props.partnerDataProgramManager}
            getProgramManagerData={props.getProgramManagerData}
            setResourceDataSelectedPartner={props.setResourceDataSelectedPartner}
            selectedProgramManager={props.selectedProgramManager}
            landingPageData={props.landingPageData}
            selectedsEntryPoint={props.selectedsEntryPoint}
            isClearClicked={props.isClearClicked}
            isResourceTableLoading={props.isResourceTableLoading}
            clearRef={props.clearRef}
            searchRef={props.searchRef}
          />

      </div>
    </div>
  )
}

export default DreamBigLandingPage
